import { render, staticRenderFns } from "./ChartBox.vue?vue&type=template&id=71be779a&scoped=true&"
import script from "./ChartBox.vue?vue&type=script&lang=js&"
export * from "./ChartBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71be779a",
  null
  
)

export default component.exports